/**
 * Determines if an unknown is Error-like.
 */
export function isErrorWithMessage(error: unknown): error is Error {
  return (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof (error as Record<string, unknown>).message === "string"
  );
}

/**
 * Converts an unknown into a proper Error.
 */
export function toErrorWithMessage(maybeError: unknown): Error {
  if (isErrorWithMessage(maybeError)) return maybeError;

  if (typeof maybeError === "string") {
    return new Error(maybeError);
  }

  try {
    return new Error(
      JSON.stringify(maybeError, Object.getOwnPropertyNames(maybeError)),
    );
  } catch {
    return new Error("Unprocessable error");
  }
}
